import { useTranslator } from '@bluebeam/react-i18n';
import HeavyLabel from 'components/Overlays/OverlaySection/OverlaySectionHeavyLabel';
import Immutable from 'immutable';
import React from 'react';
import { ProjectId } from 'records/Project';
import { RFIAttachment } from 'records/RFIAttachment';
import { SheetVersion } from 'records/SheetVersion';
import RFIOverlayAttachedDrawing from './RFIOverlayAttachedDrawing';
import RFIOverlayAttachment from './RFIOverlayAttachment';
import './RFIOverlayAttachments.css';

interface Props {
  projectId: ProjectId;
  attachments: Immutable.List<RFIAttachment>;
  attachedSheetversions: Immutable.List<SheetVersion>;
  label?: string;
}

const RFIOverlayAttachments: React.FC<Props> = ({
  label,
  attachments,
  attachedSheetversions,
  projectId,
}) => {
  const attachmentSize = attachments?.size + attachedSheetversions?.size;
  const { translate } = useTranslator(['rfiPage']);

  if (!label) label = translate('rfiPage:rfiDetails.labelAttachments');

  return (
    <div className="rfi-overlay-attachments column">
      <div className="mb1">
        <HeavyLabel label={`${label} (${attachmentSize})`} />
      </div>
      {attachmentSize === 0 ? (
        <div className="light">
          {translate('rfiPage:rfiDetails.noAttachments')}
        </div>
      ) : (
        <div className="oxa w100">
          <div className="row">
            {attachments.map((attachment) => (
              <RFIOverlayAttachment
                key={attachment.fileid}
                projectId={projectId}
                attachment={attachment}
              />
            ))}
            {attachedSheetversions.map((sv) => (
              <RFIOverlayAttachedDrawing key={sv.sheetid} sheetVersion={sv} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RFIOverlayAttachments;
